export default "__VITE_ASSET__2e26b82e__"